import { getTrackThumbnailPath, Track } from "model/Track/Track";
import { buildTrackPath } from "pages/PageConfigs";
import {
  MapperName,
  TmioButton,
  TrackGridItemDetails,
  TrackGridItemWrapper,
  TrackName,
} from "./styles";
import { PlainNavLink } from "styles/elements";

interface Props {
  track: Track;
}

export const TrackGridItem = ({ track }: Props) => {
  return (
    <TrackGridItemWrapper backgroundUrl={getTrackThumbnailPath(track)}>
      <TmioButton title="View on TM.io" href={track.link} target="_blank" />
      <PlainNavLink to={buildTrackPath(track.id)}>
        <TrackGridItemDetails>
          <TrackName>{track.name}</TrackName>
          <MapperName>{track.mapperName}</MapperName>
        </TrackGridItemDetails>
      </PlainNavLink>
    </TrackGridItemWrapper>
  );
};
